import React, { useEffect, useRef } from 'react'
import { gsap } from '../../gsap'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const componentClassNames = (className) =>
  clsx('translate-y-5 opacity-0', className)

const FadeInUpAnimation = ({
  children,
  as: Component,
  className,
  delay,
  ...props
}) => {
  const componentRef = useRef(null)

  useEffect(() => {
    const component = componentRef.current

    const ctx = gsap.context(() => {
      gsap.to(component, {
        force3D: true,
        delay,
        duration: 1,
        transform: 'translate3d(0px, 0px, 0px)',
        opacity: 1,
        scrollTrigger: {
          trigger: component,
          start: 'top 90%',
          end: 'bottom top'
        }
      })
    }, componentRef)

    return () => ctx.revert()
  }, [delay])

  return (
    <Component
      ref={componentRef}
      className={componentClassNames(className)}
      {...props}
    >
      {children}
    </Component>
  )
}

export default FadeInUpAnimation

FadeInUpAnimation.propTypes = {
  children: PropTypes.node.isRequired,
  as: PropTypes.node,
  className: PropTypes.string,
  delay: PropTypes.number
}

FadeInUpAnimation.defaultProps = {
  as: 'div',
  className: ''
}
